<template>
    <v-dialog v-model="showBulkSchedule"
            persistent
            scrollable
            fullscreen>
        <v-card>
            <v-toolbar theme="dark">
                <v-toolbar-items>
                    <v-tabs v-model="tab">
                        <v-tab text="Load Dates" value="dates"></v-tab>
                        <v-tab text="Schedule" value="schedule"></v-tab>
                    </v-tabs>
                </v-toolbar-items>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                    <v-btn icon="mdi-close"
                           @click="showBulkSchedule = false"></v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text class="p-0">
                <v-window v-model="tab">
                    <v-window-item value="dates">
                        <smart-bulk-date-updater></smart-bulk-date-updater>
                    </v-window-item>
                    <v-window-item value="schedule">
                        <smart-bulk-scheduler></smart-bulk-scheduler>
                    </v-window-item>
                </v-window>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<style scoped lang="scss">
    @import '../../../styles/smart.scss';

    .invalidSchedule {
        border:1px solid red;
        border-radius:5px;
        padding:3px;
    }
</style>
<script>
    import { mapActions, mapState, mapGetters } from "vuex";
    import { formatSearchName } from "@/mixins/searchMixins";
    import { numberWithCommas } from "@/mixins/numberMixins";
    function initialState() {
        return {
            saving: false,
            loading: false,
            tab: 'dates'
        };
    }
    export default {
        name: "SmartBulkScheduleDialog",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack",
                "refreshSmartData"
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            formatSearchName,
            numberWithCommas,
            resetInput() {
            },
        },
        computed: {
            ...mapGetters([
                'smartScheduleJobs',
            ]),
            showBulkSchedule: {
                get() {
                    return this.$store.state.smart.showBulkSchedule
                },
                set(value) {
                    this.$store.commit('setShowBulkSchedule', value)
                }
            },
        },
        watch: {
        }
    };
</script>